export default __webpack_public_path__ + "static/media/Snd_TryZ.9c6595e6.mp3";